export default __webpack_public_path__ + "static/media/3.ee617164.jpg";